module.exports = __webpack_public_path__ + "img/google-calendar-subscribe.cf42d9a6.png";